export default function getUrlParameter(parameter) {
	let url = new URL(window.location);
	return url.searchParams.get(parameter);
}